import React from 'react';
import { action } from './util';
import { LocalStorageKey } from '../common/Definitions';
import {ACTIVE_NOTIFICATIONS} from "../common/Notification";

export const NOTIFICATION_TYPE = {
  WARNING: 1,
  INFO: 2,
  ERROR: 3,
  SUCCESS: 4,
};

export const NotificationActionType = {
  RETRIEVING_NOTIFICATIONS: 'RETRIEVING_NOTIFICATIONS',
  NOTIFICATIONS_RETRIEVED: 'NOTIFICATIONS_RETRIEVED',
  HIDING_NOTIFICATION: 'HIDING_NOTIFICATION',
  NOTIFICATION_HIDDEN: 'NOTIFICATION_HIDDEN',
  NOTIFICATION_ADDED: 'NOTIFICATION_ADDED',
  ADDING_NOTIFICATION: 'ADDING_NOTIFICATION',
};

export function addNotification(id, notification, type) {
  return dispatch => {
    dispatch(addingNotification(id, notification));
    // Don't add duplicate notifications
    if (!ACTIVE_NOTIFICATIONS.find(n => n.id === id)) {
      ACTIVE_NOTIFICATIONS.push({ id, notification, type });
    }
    dispatch(notificationAdded(id, notification));
  };
}

export function addingNotification(id) {
  return action(NotificationActionType.ADDING_NOTIFICATION, { id });
}

export function notificationAdded(id) {
  return action(NotificationActionType.NOTIFICATION_ADDED, { id });
}

export function retrieveNotifications() {
  return dispatch => {
    dispatch(retrievingNotifications());

    // Get hidden notification ids
    const hiddenNotificationIds = localStorage.getItem(LocalStorageKey.HIDDEN_NOTIFICATIONS) ? localStorage.getItem(LocalStorageKey.HIDDEN_NOTIFICATIONS).split(';') : [];
    const updatedHiddenNotificationIds = [];

    // Filter hidden notifications and remove those that don't exist anymore
    const activeNotificationsIdMap = {};
    ACTIVE_NOTIFICATIONS.forEach(({ id }) => { activeNotificationsIdMap[`${id}`] = true; });
    const activeNotifications = [];
    hiddenNotificationIds.forEach(id => {
      if (activeNotificationsIdMap[id]) {
        updatedHiddenNotificationIds.push(id);
        activeNotificationsIdMap[id] = false;
      }
    });

    // Update Hidden notification ids
    localStorage.setItem(LocalStorageKey.HIDDEN_NOTIFICATIONS, updatedHiddenNotificationIds.join(';'));

    // Get notifications to show
    ACTIVE_NOTIFICATIONS.forEach(notification => {
      if (activeNotificationsIdMap[`${notification.id}`]) {
        activeNotifications.push(notification);
      }
    });

    dispatch(notificationsRetrieved(activeNotifications));
  };
}

export function retrievingNotifications() {
  return action(NotificationActionType.RETRIEVING_NOTIFICATIONS);
}

export function notificationsRetrieved(notifications) {
  return action(NotificationActionType.NOTIFICATIONS_RETRIEVED, { notifications });
}

export function hideNotification(id) {
  return dispatch => {
    dispatch(hidingNotification(id));
    let hiddenNotificationIds = localStorage.getItem(LocalStorageKey.HIDDEN_NOTIFICATIONS);
    if (hiddenNotificationIds) {
      hiddenNotificationIds += `;${id}`;
    } else {
      hiddenNotificationIds = id;
    }
    localStorage.setItem(LocalStorageKey.HIDDEN_NOTIFICATIONS, hiddenNotificationIds);
    dispatch(notificationHidden(id));
  };
}

export function hidingNotification(id) {
  return action(NotificationActionType.HIDING_NOTIFICATION, { id });
}

export function notificationHidden(id) {
  return action(NotificationActionType.NOTIFICATION_HIDDEN, { id });
}
